import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/button'
import { useCreateCraStudio } from '@/features/compliance-studio/cra/api'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductCraRegulationPageProps = {
  productId: string
}

export function V2ProductCraRegulationPage({
  productId,
}: V2ProductCraRegulationPageProps) {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const createStudio = useCreateCraStudio(productId)

  const openStudio = async () => {
    const studio = await createStudio.mutateAsync()
    navigate(`/product-catalog/${productId}/cra/${studio.id}`)
  }

  return (
    <V2ProductRegulationPageShell productId={productId} law='cra'>
      {(applies) =>
        applies ? (
          <Button
            type='button'
            size='sm'
            variant='outline'
            disabled={createStudio.isPending}
            onClick={() => {
              void openStudio()
            }}
          >
            <ExternalLink className='me-2 size-4' aria-hidden />
            {t('v2.pages.products.detail.machineryCompliance.actions.openStudio')}
          </Button>
        ) : null
      }
    </V2ProductRegulationPageShell>
  )
}
